import React from 'react';
import Feature from '../../components/feature/Feature';
import './opportunities.css';

const Opportunities = () => (
  <div className="gpt3__whatgpt3 section__margin" id="opportunities">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="Opportunities" text="We provide you with variesties of ways in which you can make your money work for you." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">Invest in Banks and Companies through</h1>
   
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Fixed Deposite" text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley" />
      <Feature title="Deposite" text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley" />
      <Feature title="Comapny Investment" text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley" />
    </div>
  </div>
);

export default Opportunities;
